// Aura-driven site placement restrictions. Salt the Earth: "Sites
// can't be played here." The aura installs a static
// BAN_SITE_PLACEMENT_AT_COVERED marker; the site-placement engine
// reads this set when computing legal cells for incoming sites.
//
// W4: server-consumed via sync. The server derives
// `boardLegality.bannedSiteCells` from this walk and enforces the
// ban at cast/SET_POSITION; auth clients read the bag from the
// mirror instead of calling this locally (sandbox still does).
//
// Pure. No GameBoard state. Returns a Set<'col,row'> the caller
// passes into `getLegalSitePlacement` as `bannedCells`.

import { anchorCoveredCells } from '../../core/auraPlacement';
import { OP, TRIGGER } from '../schema';

/**
 * Collect every covered cell of every aura carrying a
 * BAN_SITE_PLACEMENT_AT_COVERED static entry. Union across auras.
 * a cell stays banned as long as ANY aura covers it.
 *
 * @param {Iterable<[any, { userData, position }]>} meshes
 * @param {(cardId: string) => object | null} getFullCard
 * @returns {Set<string>}
 */
export function bannedSitePlacementCells(meshes, getFullCard) {
  const out = new Set();
  for (const [, mesh] of meshes) {
    const card = mesh?.userData?.cardInstance;
    if (!card || card.type !== 'Aura') continue;
    if (!card._auraShape || !card._auraAnchor) continue;
    const full = getFullCard(card.cardId);
    if (!full) continue;
    const entries = (full.automation || []).filter((e) => e.trigger === TRIGGER.STATIC);
    let bans = false;
    for (const entry of entries) {
      for (const eff of (entry.effect || [])) {
        if (eff.op === OP.BAN_SITE_PLACEMENT_AT_COVERED) { bans = true; break; }
      }
      if (bans) break;
    }
    if (!bans) continue;
    for (const key of anchorCoveredCells(card._auraAnchor, card._auraShape.shape)) {
      out.add(key);
    }
  }
  return out;
}
